import React, {useEffect, useMemo, useRef} from 'react';
import {COMPONENT_TYPE, EVENT_TYPE} from '@/const';
import {useCommonParams, useDeviceId} from '@/hooks';
import Api from '@/services/apis';
import {gaTrackEvent} from '@/helpers';

interface IntersectionObserverInitWithOnce extends IntersectionObserverInit {
  once?: boolean;
}

const IntersectionObserverComponent = (props: any) => {
  const {
    children,
    gpMappSeq,
    adsDtlSeq,
    adsSeq,
    payYn,
    componentName,
    adCategoryCd,
    compNm,
    loanName,
    cardName,
    insuName,
    savingName,
    subTitle,
    page,
    refEventId,
  } = props;
  const ref = useRef<any>(null);
  const {trackCd, osType, mediaSeq, trackCdType} = useCommonParams();
  const [deviceId] = useDeviceId();
  let rollingCount = 0

  const options: IntersectionObserverInitWithOnce = useMemo(
    () => ({
      root: null,
      threshold: 1,
      once: true,
    }),
    [],
  );

  const params = useMemo(() => {
    return {
      trackCd,
      trackCdType,
      adCategoryCd,
      gpMappSeq,
      adsDtlSeq,
      adsSeq,
      payYn,
      platformCd: osType,
      eventType: EVENT_TYPE.IMPRESSION.DEFAULT,
      deviceId,
      mediaSeq,
      componentName,
      compNm,
      loanName,
      cardName,
      insuName,
      savingName,
      subTitle,
      page,
      refEventId,
    };
  }, [trackCd, trackCdType, adCategoryCd, gpMappSeq, adsDtlSeq, adsSeq, payYn, osType, deviceId, mediaSeq, componentName, compNm, loanName, cardName, insuName, savingName, subTitle]);

  useEffect(() => {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const isRolling = componentName === COMPONENT_TYPE.ROLLING;
        // @ts-ignore
        const rollingElement = entry?.target?.parentNode?.className;
        const isActiveSlide = rollingElement.includes('swiper-slide-active');
        const isMaxiumCount = rollingCount === 4

        if (entry.isIntersecting && trackCd && deviceId && isActiveSlide && isRolling) {
          Api.postCustTrxLog({trackCd, condition: params})
          gaTrackEvent(params);
          if (isMaxiumCount) {
            io.unobserve(entry.target);
          }
          rollingCount++
        }

        if (entry.isIntersecting && trackCd && deviceId && !isRolling) {
          Api.postCustTrxLog({trackCd, condition: params})
          gaTrackEvent(params);
          io.unobserve(entry.target);
        }

      });
    }, options);
    io.observe(ref.current);
    return () => {
      io.disconnect();
    };
  }, [componentName, deviceId, options, params, rollingCount, trackCd]);

  return (
    <div ref={ref} className="intersection-observer-wrap">
      {children}
    </div>
  );
};

/**
 * Component definition is missing display name 에러는 React 컴포넌트가 이름을 가지고 있지 않을 때 발생하는 경고 메시지.
 */
IntersectionObserverComponent.displayName = 'IntersectionObserverComponent';

export default IntersectionObserverComponent;
